export const servicesData = {
  photography: [
    "Businessporträts & Corporate Headshots",
    "Immobilien- & Architekturfotografie",
    "Produkt- & Foodfotografie",
    "Lifestyle- & Teamporträts",
    "Kampagnenshootings",
    "Editorial- & Magazinfotografie",
    "Social-Media-Fotografie für Start-ups & Influencer",
    "Drohnenfotografie",
    "Model- & Fashionfotografie",
    "Kampagnen- & Eventreportagen",
    "Website-Fotografie",
    "Hochzeitsfotografie",
    "Familien- & Kinderporträts",
    "Sportfotografie & Actionshots",
    "Konzert- & Veranstaltungsfotografie",
    "Kunstfotografie & Fine Art",
    "Tierfotografie",
    "Landschafts- & Naturfotografie",
    "Produktstyling & E-Commerce",
    "360°-Fotografie & Virtuelle Rundgänge"
  ],
  videography: [
    "Imagefilm / Unternehmensfilm",
    "Industriefilm",
    "Produktfilm",
    "Werbefilm / Commercial",
    "Promotionsfilm",
    "Recruitingfilm / Employer Branding",
    "Schulungs- & E-Learning-Videos",
    "Erklärfilm (ohne Animation)",
    "Dokumentation / Reportage",
    "Eventfilm / Messefilm",
    "Interview- & Testimonialfilm",
    "Drohnenaufnahmen",
    "Musikvideoclips",
    "Hochzeitsfilm",
    "Social-Media-Video-Content (Reels, TikTok, Stories)",
    "Livestreaming & Webcast",
    "After-Movie & Eventtrailer",
    "Sportfilme & Action-Aufnahmen",
    "Immobilien-Videos & Walkthroughs",
    "Making-of & Behind the Scenes",
    "Animations- & Motion-Graphics-Integration",
    "Podcast-Aufzeichnung & Videoproduktion"
  ],
  "social-media": [
    "Social-Media-Strategie & Roadmap",
    "Content Creation (Posts, Carousels, Stories)",
    "Redaktions- & Content-Planung",
    "Brand Storytelling & Messaging",
    "Profil- & Plattformoptimierung",
    "Trend-Content & Newsjacking",
    "Content Repurposing & Adaption",
    "User Generated Content (UGC)",
    "Influencer- & Micro-Influencer-Kooperationen (organisch)",
    "Formatentwicklung & Innovation",
    "Kamera-Coaching",
    "Analytics & Reporting (organisch)",
    "Tone of Voice & Style Guidelines",
    "Reels & Short-Form-Video-Produktion",
    "Instagram- & TikTok-Content-Strategie",
    "LinkedIn-Content für B2B",
    "Community Management & Engagement",
    "Social-Media-Kampagnen",
    "Hashtag-Strategie & Recherche",
    "Plattformübergreifende Content-Adaption",
    "Storytelling für Social Media",
    "Brand Ambassador Programme"
  ]
};
